import React from 'react'
import PropTypes from 'prop-types'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { renderRawWithLinksHack } from './Utilities/RichTextRenderer'

function Disclosures({ data }) {
  return (
    <div className="footer-legal">
      <div className="container__inner">
        <div className="footer-legal__text-box">
          {/* eslint-disable react/no-array-index-key */}
          {data &&
            data.legalStatements?.map((legalStatement, index) => {
              if (legalStatement.paragraph) {
                return (
                  <div key={index} className="footer-legal__text">
                    {documentToReactComponents(JSON.parse(legalStatement.paragraph.raw))}
                  </div>
                )
              }
              if (legalStatement.styleFeatures?.indexOf('Boxed') > -1) {
                return (
                  <p className="footer-legal__text boxed" key={index}>
                    {renderRawWithLinksHack(legalStatement.statement)}
                  </p>
                )
              }
              return (
                <p className="footer-legal__text" key={index}>
                  {renderRawWithLinksHack(legalStatement.statement, 'flat-link--grey-dark')}
                </p>
              )
            })}
        </div>

        <div className="footer-legal__icons-box">
          {data &&
            data.logos?.map((logo, index) => {
              return (
                <GatsbyImage
                  imgClassName="footer-legal__icon"
                  key={index}
                  image={getImage(logo.image)}
                  alt={logo.altText}
                />
              )
            })}
        </div>
      </div>
    </div>
  )
}

Disclosures.defaultProps = {
  data: null
}

Disclosures.propTypes = {
  data: PropTypes.object
}

export default Disclosures
